import { InjectionToken } from '@angular/core';

export interface UsersAndRolesAPI {
	url: string;
}

export const USERS_AND_ROLES_API = new InjectionToken<UsersAndRolesAPI>('UsersAndRolesAPIUrlPart');